
import { getSecondsTilSiteExpiration } from "@/futurelayer/connector/util";
import { singularityStore } from "@/store/store";
import { getFutureLayerAppUrlWithReturnTo } from "@/futurelayer/app/app";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({})
export default class FutureLayerDaysRemainingBadge extends Vue {
  currentTime: number = Date.now();
  intervalId: number | null = null;

  get siteState() {
    return singularityStore.siteStatus.siteState;
  }

  get siteId(): number | null {
    if (!this.siteState || 'error' in this.siteState) return null;
    if (this.siteState.type === 'claimed') {
      return this.siteState.site_id;
    }
    return null;
  }

  get secondsRemaining(): number | null {
    // Reference currentTime to make this reactive to time updates
    this.currentTime;
    return getSecondsTilSiteExpiration();
  }

  get timeRemaining() {
    if (this.secondsRemaining === null) return null;
    if (this.secondsRemaining <= 0) return { days: 0, hours: 0, minutes: 0 };

    const days = Math.floor(this.secondsRemaining / (24 * 60 * 60));
    const hours = Math.floor((this.secondsRemaining % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((this.secondsRemaining % (60 * 60)) / 60);

    return { days, hours, minutes };
  }

  get daysRemainingText() {
    if (this.timeRemaining === null) return 'unknown expiration date';

    const { days, hours, minutes } = this.timeRemaining;

    if (days === 0 && hours === 0 && minutes === 0) {
      return 'act now to prevent site deletion';
    }

    // When less than 24 hours, show hours and minutes
    if (days === 0) {
      if (hours === 0) {
        return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} remaining`;
      }
      return `${hours} ${hours === 1 ? 'hour' : 'hours'} ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} remaining`;
    }

    // When 1 or more days, show days and hours
    if (days === 1) {
      return `1 day ${hours} ${hours === 1 ? 'hour' : 'hours'} remaining`;
    }

    return `${days} days ${hours} ${hours === 1 ? 'hour' : 'hours'} remaining`;
  }

  navigateToSitePage() {
    if (!this.siteId) {
      console.warn('No site ID available');
      return;
    }

    const url = getFutureLayerAppUrlWithReturnTo(`/sites/expiring/${this.siteId}`);
    window.location.href = url;
  }

  mounted() {
    // Update currentTime every 60 seconds to trigger recalculation
    this.intervalId = window.setInterval(() => {
      this.currentTime = Date.now();
    }, 60 * 1000);
  }

  beforeDestroy() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }
}
